import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { contratosApi, clientesApi } from '../services/api';
import { MENU_SISTEMA } from '../lib/menuSistema';

/**
 * Busca rápida (⌘K / Ctrl+K): empresa por nome, CNPJ ou CPF, e qualquer tela.
 *
 * [2026-10-20] As telas saem do MESMO menu que a pessoa vê (o layout passa
 * `menu`, já filtrado pelo papel, pela área de testes e pela engrenagem do
 * admin). Antes era uma lista própria, que ficou apontando para telas que já
 * tinham saído (Bandeja, Hoje, PGDAS-D Corrida, controle antigo) e não sabia
 * das novas. Aqui só ficam as palavras extras de busca de cada tela.
 */
const PALAVRAS = {
  '/escritorio/agenda': 'agenda e reuniões marcar reunião, convidar a equipe, lembretes agenda reuniao reunião calendario calendário teams convite lembrete marcar',
  '/escritorio/ana': 'painel ana métricas e config do agente agente ia metricas',
  '/escritorio/apuracao': 'apuração tributária simular regimes e enviar pra fila tributos simples',
  '/escritorio/audit': 'audit log histórico de ações sensíveis auditoria seguranca log',
  '/escritorio/balancetes': 'contábil · domínio: balancetes (joão) extrato → classificação → txt do domínio + balancete pdf joao balancete balancetes extrato extratos conciliacao contabilidade lancamentos txt dominio importacao importador plano de contas saldo inicial razao ofx',
  '/escritorio/cadastros': 'cadastros · fila de aprovação pedidos do app + propostas do drive — nada vira cliente sem aprovar aqui cadastro cadastros solicitacao solicitacoes fila aprovar aprovacao onboarding novo cliente lead pedido drive proposta protocolo',
  '/escritorio/certificado-serpro': 'certificado serpro status do setup serpro cert marcal',
  '/escritorio/chat': 'chat da equipe conversas internas: pessoas, grupos e setores chat equipe teams mensagem conversa interna grupo setor colega audio',
  '/escritorio/clientes': 'gestão de clientes cadastro e dados clientes cadastro carteira',
  '/escritorio/contabil': 'contábil · cockpit: lançamentos e demonstrações contabilização automática, razão, diário, dre, balanço, encerramento contabil cockpit erp lancamentos razao diario dre balanco encerramento contabilizacao',
  '/escritorio/contabil/painel': 'contábil · cockpit: painel do mês extrato, contabilização, conferência, títulos e fechamento por empresa contabil cockpit painel mes carteira fechamento pendencias',
  '/escritorio/contratos': 'contratos gerar contrato de prestação de serviços (restrito) contrato contratos honorario honorarios exito prestacao servicos assessoria contabil timbrado',
  '/escritorio/controle-certificados': 'certificados vencimentos, envio de arquivo, senha e renovações certificado pfx digital a1 e-cnpj e-cpf vencimento validade vencido enviar renovar senha',
  '/escritorio/dctf': 'controle dctfweb (12 meses) matriz de entrega da carteira + atrasos dctf dctfweb entrega recibo atraso multa matriz 12 meses',
  '/escritorio/documentos': 'central de documentos certidões e declarações por empresa documentos certidao declaracao faturamento pasta drive interno',
  '/escritorio/dominio': 'api domínio configuração onvio onvio thomson reuters',
  '/escritorio/drive-clientes': 'drive clientes espelho hierárquico do onedrive onedrive arquivos certificado extrato',
  '/escritorio/emitir-nota': 'emitir nota produto (nf-e) ou serviço (nfs-e) emitir nfse nfe nota servico produto',
  '/escritorio/empresa': 'ficha da empresa cadastro, regime por vigência, bancos, parâmetros por módulo, mapa de integração, participantes ficha empresa cadastro regime bancos parametros mapa integracao participantes estabelecimentos responsaveis contador',
  '/escritorio/entregas-serpro': 'ação hoje · vencimentos worklist de pendências + das a vencer acao hoje vencimentos das worklist pendencias fila a vencer entregas serpro',
  '/escritorio/equipe': 'gestão da equipe usuários com acesso usuarios equipe bruno lucas janaina',
  '/escritorio/fila-ana': 'fila ana ações aguardando aprovação aprovacao whatsapp',
  '/escritorio/imobilizado': 'contábil · cockpit: imobilizado e depreciação bens, depreciação mensal, baixa imobilizado depreciacao bens ativo',
  '/escritorio/integra-contador': 'integra contador das, dctfweb, darf, sitfis, ccmei serpro fiscal das darf',
  '/escritorio/joao': 'joão — detalhe daemon detalhe do daemon local daemon mac heartbeat',
  '/escritorio/layouts-dominio': 'layouts domínio csvs gerados + importação joão csv importacao dominio onvio',
  '/escritorio/mapa': 'mapa do sistema arquitetura viva + status das integrações mapa arquitetura topologia onboarding integracao status render deploy',
  '/escritorio/notas': 'controle de notas notas por cliente e mês notas fiscais historico todas controle cliente mes',
  '/escritorio/painel-obrigacoes': 'painel geral de obrigações ecd/ecf/dctf/caixa postal por cliente e regime painel geral obrigacoes ecd ecf dctf caixa postal fechamento balancete regime',
  '/escritorio/performance': 'performance técnica evolução e atividade das rotinas performance evolucao joao grafico',
  '/escritorio/reinf': 'efd-reinf · serviços tomados notas recebidas no portal nacional + retenções · real e presumido reinf efd-reinf efdreinf servicos tomados retencao retencoes irrf pis cofins csll csrf inss r-4020 r4020 r-2010 r2010 r-4099 r4099 fonte pagadora beneficiario portal nacional dctfweb',
  '/escritorio/prestacao-cosems': 'prestação de contas cosems anexo i quadrimestral ao conasems prestacao contas cosems conasems anexo i rpc quadrimestre pr sc am ac portaria 220 extrato',
  '/escritorio/relatorios-contabeis': 'relatórios contábeis últimos 12 meses da carteira · mensal e trimestral relatorio relatorios contabil contabeis fechamento 12 meses doze mensal trimestral anual faturamento carga tributaria irpj csll limite sublimite exercicio',
  '/escritorio/reports': 'bug reports bugs reportados pela equipe bug erro report',
  '/escritorio/societario': 'societário hub: licenças + processos na junta societario junta comercial jucepar jucisrs abertura alteracao contrato',
  '/escritorio/testar-agente': 'testar a ana conversa de teste com a ana sandbox teste ana ia',
  '/escritorio/leticia-chamados': 'leticia chamados assistente analise de chamado ia',
  '/escritorio/transicao-clientes': 'transição de clientes esteira de onboarding: e-mail padrão, cobrança e documentos transicao clientes novo cliente onboarding esteira email padrao documentos cobranca contabilidade anterior pasta drive',
  '/escritorio/whatsapp': 'whatsapp configurações z-api zapi mensagem',
};

const semAcento = (t) => String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

/** Lista de telas do menu: { label, hint, path, busca }. PURA. */
export function telasDoMenu(menu) {
  const out = [];
  const vistos = new Set();
  for (const m of (Array.isArray(menu) ? menu : [])) {
    let secao = null;
    for (const it of (m.itens || [])) {
      if (it.sep) { secao = it.sep; continue; }
      if (!it.to || vistos.has(it.to)) continue;
      vistos.add(it.to);
      const hint = [m.label, secao].filter(Boolean).join(' › ');
      out.push({ label: it.label, hint, path: it.to, busca: semAcento(`${it.label} ${hint} ${PALAVRAS[it.to] || ''}`) });
    }
  }
  return out;
}

export default function CommandPalette({ menu = MENU_SISTEMA }) {
  const [aberto, setAberto] = useState(false);
  const [query, setQuery] = useState('');
  const [selecionado, setSelecionado] = useState(0);
  const inputRef = useRef(null);
  const navigate = useNavigate();
  // Contratos é RESTRITO por e-mail — só entra na lista se o backend liberar.
  const [contratosOk, setContratosOk] = useState(false);
  useEffect(() => {
    if (!aberto || contratosOk) return;
    contratosApi.acesso().then((r) => { if (r?.data?.permitido) setContratosOk(true); }).catch(() => {});
  }, [aberto, contratosOk]);

  // A carteira é carregada ao abrir (1× por sessão do componente).
  const [empresas, setEmpresas] = useState(null);
  useEffect(() => {
    if (!aberto || empresas) return;
    clientesApi.listar()
      .then((r) => setEmpresas(Array.isArray(r?.data) ? r.data : (r?.data?.clientes || [])))
      .catch(() => setEmpresas([]));
  }, [aberto, empresas]);

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setAberto(a => !a);
        setQuery('');
        setSelecionado(0);
      } else if (e.key === 'Escape' && aberto) {
        setAberto(false);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [aberto]);

  useEffect(() => {
    if (aberto) setTimeout(() => inputRef.current?.focus(), 50);
  }, [aberto]);

  // O botão de busca do topo abre a paleta por aqui.
  useEffect(() => {
    window.__abrirCommandPalette = () => setAberto(true);
    return () => { delete window.__abrirCommandPalette; };
  }, []);

  const telas = useMemo(
    () => telasDoMenu(menu).filter((t) => contratosOk || t.path !== '/escritorio/contratos'),
    [menu, contratosOk],
  );

  const q = query.trim();
  const qTxt = semAcento(q);
  const qDig = q.replace(/\D/g, '');
  const palavras = qTxt.split(/\s+/).filter(Boolean);
  const filtrados = palavras.length ? telas.filter((t) => palavras.every((p) => t.busca.includes(p))) : telas;

  const achadas = (q.length >= 2 && Array.isArray(empresas))
    ? empresas.filter((c) => {
      const doc = String(c.cnpj || c.cpf || '').replace(/\D/g, '');
      if (qDig.length >= 3 && doc.includes(qDig)) return true;
      const nome = semAcento(`${c.razao_social || ''} ${c.nome_fantasia || ''}`);
      return palavras.length > 0 && palavras.every((p) => nome.includes(p));
    }).slice(0, 8).map((c) => {
      const doc = String(c.cnpj || '').replace(/\D/g, '');
      const docFmt = doc.length === 14 ? `${doc.slice(0, 2)}.${doc.slice(2, 5)}.${doc.slice(5, 8)}/${doc.slice(8, 12)}-${doc.slice(12)}` : (c.cnpj || '');
      return {
        empresa: true,
        label: c.razao_social || c.nome_fantasia || docFmt,
        casa: c.origem === 'nivelon' ? 'nivelon' : 'meu_contador',
        hint: [docFmt, c.regime_tributario, c.ativo === 0 ? 'inativa' : null].filter(Boolean).join(' · '),
        path: `/escritorio/clientes?editar=${c.id}`,
        documentos: `/escritorio/documentos?cliente_id=${c.id}`,
        drive: `/escritorio/drive-clientes?cliente_id=${c.id}`,
      };
    })
    : [];
  // Empresa primeiro: quem digita um CNPJ quer a empresa, não uma tela.
  const resultados = [...achadas, ...(achadas.length && qDig.length >= 3 ? [] : filtrados)];

  const irPara = (cmd, destino) => {
    navigate(destino || cmd.path);
    setAberto(false);
  };

  const handleKey = (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelecionado(s => Math.min(s + 1, resultados.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelecionado(s => Math.max(s - 1, 0));
    } else if (e.key === 'Enter' && resultados[selecionado]) {
      e.preventDefault();
      const r = resultados[selecionado];
      // Alt+Enter numa empresa abre a pasta dela na Central de documentos (Enter abre os dados).
      irPara(r, e.altKey && r.documentos ? r.documentos : undefined);
    }
  };

  if (!aberto) return null;

  return (
    <div className="cmdk-backdrop" onClick={() => setAberto(false)}>
      <div className="cmdk-panel" onClick={e => e.stopPropagation()}>
        <input
          ref={inputRef}
          className="cmdk-input"
          placeholder="Buscar empresa (nome, CNPJ ou CPF) ou tela…"
          value={query}
          onChange={e => { setQuery(e.target.value); setSelecionado(0); }}
          onKeyDown={handleKey}
        />
        <div className="cmdk-list" role="listbox">
          {resultados.length === 0 ? (
            <div className="cmdk-empty">
              {q && empresas === null ? 'Carregando empresas…' : `Nenhuma empresa ou tela para "${query}"`}
            </div>
          ) : (
            resultados.map((cmd, i) => (
              <div
                key={cmd.path + cmd.label}
                className="cmdk-item"
                aria-selected={i === selecionado}
                onClick={() => irPara(cmd)}
                onMouseEnter={() => setSelecionado(i)}
                role="option"
              >
                <span className="cmdk-icon" aria-hidden>{cmd.empresa ? '▣' : '→'}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ color: 'var(--text)', fontWeight: 500 }}>
                    {cmd.label}
                    {cmd.empresa && (
                      <span className={`cmdk-casa cmdk-casa--${cmd.casa}`}>{cmd.casa === 'nivelon' ? 'NivelOn' : 'Meu Contador'}</span>
                    )}
                  </div>
                  <div style={{ color: 'var(--text-muted)', fontSize: 11.5, marginTop: 2 }}>{cmd.hint}</div>
                </div>
                {cmd.empresa && (
                  <>
                    <button type="button" className="cmdk-acao" title="Dados da empresa (Enter)"
                      onClick={(e) => { e.stopPropagation(); irPara(cmd); }}>Dados</button>
                    <button type="button" className="cmdk-acao" title="Pasta da empresa na Central de documentos (Alt+Enter)"
                      onClick={(e) => { e.stopPropagation(); irPara(cmd, cmd.documentos); }}>Documentos</button>
                    <button type="button" className="cmdk-acao" title="Pastas da empresa no Drive (OneDrive)"
                      onClick={(e) => { e.stopPropagation(); irPara(cmd, cmd.drive); }}>Drive</button>
                  </>
                )}
                {i === selecionado && !cmd.empresa && <span className="cmdk-shortcut">↵</span>}
              </div>
            ))
          )}
        </div>
        {achadas.length > 0 && (
          <div className="cmdk-dica">Enter abre os dados da empresa · Alt+Enter abre a Central de documentos dela</div>
        )}
      </div>
    </div>
  );
}
